"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// default : (idx, atom, values) => { id : atom.id, idx, value : atom.default}
// atom : (idx, atom, values) => atom,
// value:(idx, atom, value, values) => value,
//import { getAccountsForAtom, getEventsForAtom } from "../utils/debtinator-atom";
var processors = {};
var _default = processors;
exports.default = _default;